"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _reactReduxI18n = require("react-redux-i18n");

var _momentTimezone = _interopRequireDefault(require("moment-timezone"));

var _documents = require("../../../utils/documents");

var _StatusIcon = _interopRequireDefault(require("../../StatusIcon"));

var _jsxRuntime = require("react/jsx-runtime");

function DocumentState(props) {
  var documentState = props.document.state;

  function getStateLabel() {
    if (props.document.unpublished) {
      return _reactReduxI18n.I18n.t('document.documentDetails.unpublished', {
        interpolation: {
          escapeValue: false
        }
      });
    }

    if (_documents.DOCUMENT_STATE.ALMOST_EXPIRED === documentState) {
      return _reactReduxI18n.I18n.t("document.documentDetails.state.".concat(_documents.DOCUMENT_STATE.ALMOST_EXPIRED), {
        time: (0, _momentTimezone.default)(props.document.validityEnd).fromNow(),
        interpolation: {
          escapeValue: false
        }
      });
    }

    if (_documents.DOCUMENT_STATE.EXPIRED === documentState) {
      return _reactReduxI18n.I18n.t("document.documentDetails.state.".concat(_documents.DOCUMENT_STATE.EXPIRED), {
        time: (0, _momentTimezone.default)(props.document.validityEnd).fromNow(),
        interpolation: {
          escapeValue: false
        }
      });
    }

    var key = "document.documentDetails.state.".concat(documentState);
    var until = '';

    if (_documents.DOCUMENT_STATES_VALID.includes(documentState) && Boolean(props.document.validityEnd)) {
      until = _reactReduxI18n.I18n.t('document.documentDetails.validityEndLineForValid', {
        validityEnd: _reactReduxI18n.I18n.l(props.document.validityEnd, {
          dateFormat: 'datetime.shortDate'
        })
      });
    }

    return _reactReduxI18n.I18n.t(key, {
      until: until,
      interpolation: {
        escapeValue: false
      }
    });
  }

  function getStatusIcon() {
    if (props.document.unpublished) {
      return 'clock';
    }

    switch (documentState) {
      case _documents.DOCUMENT_STATE.NOT_APPLICABLE:
        return 'not-applicable';

      case _documents.DOCUMENT_STATE.VALID:
      case _documents.DOCUMENT_STATE.SIGNED:
        return 'check';

      case _documents.DOCUMENT_STATE.ALMOST_EXPIRED:
        return 'warning';

      case _documents.DOCUMENT_STATE.EXPIRED:
      case _documents.DOCUMENT_STATE.MISSING:
      case _documents.DOCUMENT_STATE.REJECTED:
      case _documents.DOCUMENT_STATE.AWAITING_SIGNATURE:
        return 'cross';

      default:
        return 'clock';
    }
  }

  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
    className: "inline-container no-wrap",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_StatusIcon.default, {
      status: getStatusIcon()
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      dangerouslySetInnerHTML: {
        __html: getStateLabel()
      }
    })]
  });
}

DocumentState.propTypes = {
  document: (0, _documents.documentPropTypes)().isRequired
};
var _default = DocumentState;
exports.default = _default;
//# sourceMappingURL=DocumentState.js.map